import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSuitcaseTag24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconSuitcaseTag24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11 4.5h2A1.5 1.5 0 0 1 14.5 6v1h-5V6A1.5 1.5 0 0 1 11 4.5M8 7V6a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3zm0 1.5H5A1.5 1.5 0 0 0 3.5 10v8A1.5 1.5 0 0 0 5 19.5h3V16H7a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h1zM9.5 11h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1v3.5h5v-11h-5zM19 8.5h-3v11h3a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 19 8.5M6.5 13a.5.5 0 0 1 .5-.5h3.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSuitcaseTag24);
